<template>
    <div class="publish_home_div">
        <!--<Publish></Publish>-->
        <MainQuestionPublish class="main_questions"></MainQuestionPublish>
        <Side class="side_questions"></Side>
    </div>
</template>

<script type="text/javascript">

    import Publish from '@/components/publish_page/publish.vue'
    import MainQuestionPublish from '@/components/publish_page/main_question_publish.vue'
    import MainQuestions from '@/components/questions_page/sub_components/main_questions.vue'
    import Side from '@/components/questions_page/sub_components/side.vue'
    import {mapState, mapActions} from 'vuex'

    export default {
        components: {
            MainQuestionPublish,
            MainQuestions,
            Side,
            Publish,
        },
        methods: {
            ...mapActions({
                get_question_list: 'questions/change_question_list_information',
                get_related_stuff: 'questions/get_related_stuff',
                // checkin: 'user/checkin'
            })
        },
        mounted: function () {
            this.get_related_stuff()
            // this.checkin({'method': 'GET'})
        }
    }
</script>
<style type="text/css" scoped>
    .publish_home_div {
        display: flex;
        width: 1170px;
        margin-bottom: 10px;
        margin-left: auto;
        margin-right: auto;
    }

    .main_questions {
        width: 75%;
    }

    .side_questions {
        width: 25%;
    }
</style>
